module.exports = __webpack_public_path__ + "709e1cfbdc54ef410bee2d29a09e32d2.png";